import React, {Component, useEffect, useState} from 'react';
import {NavLink, useNavigate, useParams} from 'react-router-dom';
import Logout from "../Auth/Logout";
import { trans } from '../utils';
import logo from '../../assets/img/logo.png';
import axios from 'axios';
import { SystemUrl } from '../../App';
import Template from "../Template";
import config from "../../config.js";
import Notifications from "./Notifications.jsx";
import { useSelector, useDispatch } from 'react-redux';
import { setUserProfile } from '../../reducer';


const changeLang = (lang) => {

    axios.post(SystemUrl + 'changeLang', { lang: lang }).then(res => {
        if (res.data.status == true) {
            localStorage.setItem('lang', lang);
            localStorage.setItem('styleUrl', urls[lang]);
            document.documentElement.setAttribute('lang', lang);
            document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
            window.location.reload(false);
        }
    });
    // localStorage.setItem('lang', lang);
    // localStorage.setItem('styleUrl', this.urls[lang])

    // window.location.reload(false);
}
const lang = localStorage.getItem('lang') == 'en' ? 'ar' : 'en';
const urls = { en: "/assets/css/main-modular.css", ar: '/assets/css/main-modular.rtl.css' }

const Header = (ComponentToRenderData) => {

    const navigate = useNavigate();
    const routeChange = path => {
        navigate(path);
    }
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const dispatch = useDispatch();

    const [localData, setLocalData] = useState(null);

    const reduxProfile = useSelector((state) => state.userProfile?.data);
    const cachedProfile = (() => {
        try {
            const raw = localStorage.getItem('userProfile');
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    })();

    // Check if profile exists with valid data
    const profileData = (reduxProfile && (reduxProfile.name || reduxProfile.email || reduxProfile.id))
        ? reduxProfile
        : (cachedProfile && (cachedProfile.name || cachedProfile.email || cachedProfile.id))
            ? cachedProfile
            : localData;

    const data = profileData || {};

    useEffect(() => {
        // If profile does not exist in state/cache, send request to get data
        if (!profileData) {
            const headers = {
                "Accept": "application/json",
                "lang": "en"
            };
            if (token) {
                headers['Authorization'] = "Bearer " + token;
            }

            axios(config.SystemUrl + `Profile/0`, { headers })
                .then(result => {
                    const fetched = result.data?.data?.data || result.data?.data || result.data;
                    if (fetched && (fetched.name || fetched.email || fetched.id)) {
                        setLocalData(fetched);
                        dispatch(setUserProfile(fetched));
                    }
                })
                .catch(err => {
                    console.error('[Header] Failed to fetch profile:', err);
                });
        }
    }, [profileData, token, dispatch])

        return (
            <div id="kt_header" className="header align-items-stretch">

                <div className="container-fluid d-flex align-items-stretch justify-content-between">
                    <div className="d-flex align-items-stretch justify-content-between flex-grow-1 w-100">
                        <div className="d-flex align-items-stretch" id="kt_header_nav">
                            <div className="header-menu align-items-stretch" >
                                <div
                                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-0 align-items-stretch"
                                    id="kt_header_menu" data-kt-menu="true">
                                    <div className="menu-item me-lg-1 d-flex align-items-center">
                                        <NavLink to={'/dashboard'} className={({ isActive }) => `menu-link py-3 ${isActive ? 'active' : ''}`}>
                                            <span className="menu-title">{trans('Dashboard')}</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="topbar d-flex align-items-center flex-shrink-0">
                            <div className="d-flex align-items-center ms-1 ms-lg-3">
                                <Notifications />
                            </div>

                            <div className="d-flex align-items-center ms-1 ms-lg-3">
                                <div className="dropdown">
                                    <button
                                        type="button"
                                        className="btn btn-icon"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-label="User Profile"
                                    >
                                        <i className="bi bi-person"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-end menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold fs-6 w-auto min-w-200px p-0 shadow-lg border"
                                         aria-labelledby="navbarDropdownMenuLink-5">
                                        <div className="menu-item px-3">
                                            <div className="menu-content d-flex align-items-center px-3">
                                                <div className="symbol symbol-50px me-5">
                                                    <i className="bi bi-people fs-3"></i>
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <div className="fw-bolder d-flex align-items-center fs-5">
                                                        {data?.name}
                                                        <span
                                                            className="badge bg-light text-dark fw-bolder fs-8 px-2 py-1 ms-2">{data?.type}</span>
                                                    </div>
                                                    <span className="fw-bold text-muted text-primary fs-7">{data?.email}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="separator my-1"></div>
                                        <div className="menu-item">
                                            <a className="menu-link px-5 d-flex text-decoration-none"
                                               data-container="body" onClick={() => {
                                                let url = "/Profile/View";
                                                routeChange(url);
                                            }}>
                                                <span className="symbol symbol-20px me-4">
                                                <i className="bi bi-gear fs-3"></i>
                                                    </span>
                                                {trans('Edit Profile')}
                                            </a>
                                        </div>
                                        <div className="menu-item">
                                            <a className="menu-link px-5 d-flex text-decoration-none" onClick={() => changeLang(lang)}>
                                                <span className="symbol symbol-20px me-4">
                                                    <i className="bi bi-globe fs-3"></i></span>
                                                {trans('lang')}
                                            </a>
                                        </div>
                                        <div className="separator my-1"></div>
                                        <div className="menu-item">
                                            <Logout />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        );

}
export default Header
